import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchBoardManageList, fetchBoardManageItem, postBoardManageItem, putBoardManageItem, deleteBoardManageItem } from ".";
import { isDebug } from "../../utils";


export const useBoardManageListQuery = (queryOptions) => {
    return useQuery({
        queryKey: ["board-manage-of-list", queryOptions],
        queryFn: () => fetchBoardManageList(queryOptions),
        select: (response) => {
            return response.data || {};
        },
        onError: (error) => {
            console.error("Error fetching Board Manage List API contracts:", new Date().toISOString(), error);
        },
        staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
        refetchOnWindowFocus: false,
    });
};

export const useBoardManageItemQuery = (manage_id) => {
    return useQuery({
        queryKey: ["board-manage-of-item", manage_id],
        queryFn: () => fetchBoardManageItem(manage_id),
        select: (response) => {
            return response.data || {};
        },
        onError: (error) => {
            console.error("Error fetching Board Manage item API contracts:", new Date().toISOString(), error);
        },
        staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
        refetchOnWindowFocus: false,
        enabled: manage_id > 0,
    });
};

export const useBoardManageItemPostMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: postBoardManageItem,
        onSuccess: () => {
            if (isDebug()) console.log("#@#@ Board Manage item posted successfully!", new Date().toISOString());
            queryClient.invalidateQueries(["post-board-manage-item"]);
        },
        onError: (error) => {
            console.error("#@#@ Failed to post Board Manage item :", new Date().toISOString(), error);
        },
    });
};

export const useBoardManageItemPutMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: putBoardManageItem,
        onSuccess: () => {
            if (isDebug()) console.log("#@#@ BoardManage item put successfully!", new Date().toISOString());
            queryClient.invalidateQueries(["put-board-manage-item"]);
        },
        onError: (error) => {
            console.error("#@#@ Failed to put Board Manage item :", new Date().toISOString(), error);
        },
    });
};

export const useBoardManageItemDeleteMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteBoardManageItem,
        onSuccess: () => {
            if (isDebug()) console.log("#@#@ Board Manage item deleted successfully!", new Date().toISOString());
            queryClient.invalidateQueries(["delete-board-manage-item"]);
        },
        onError: (error) => {
            console.error("#@#@ Failed to delete Board Manage item :", new Date().toISOString(), error);
        },
    });
};